import classNames from "classnames";
import { FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./style.scss";

interface Props {
  history: {
    route?: string;
    label: string;
  }[];
  current: string;
  className?: string;
}
export const Breadcrumb = ({ history, className, current }: Props) => {
  return (
    <div className={classNames("breadcrumb-control", className)}>
      {history.map(({ route, label }) => (
        <div className="d-flex" key={label}>
          {route ? (
            <Link to={route} className="breadcrumb-control__item">
              {label}
            </Link>
          ) : (
            <div className="breadcrumb-control__item">{label}</div>
          )}
          <FaChevronRight size={12} />
        </div>
      ))}
      <div className="breadcrumb-control__item">{current}</div>
    </div>
  );
};
